import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ClientService } from '../client/client.service';
import { AuthenticationService } from '../authentication/authentication.service';
import { IoService } from '../io/io.service';
import { Location } from '@angular/common';
import packageJson from '../../../../package.json';


@Injectable({
  providedIn: 'root'
})
export class SupportService {

  public version: string = packageJson.version;

  private supportActive: boolean = false;
  private supportActiveSubject = new Subject<boolean>();
  supportActive$: Observable<boolean> = this.supportActiveSubject.asObservable();

  private supportDocs: any;
  private supportDocsSubject = new Subject<any>();
  supportDocs$: Observable<any> = this.supportDocsSubject.asObservable();

  private supportDoc: any;
  private supportDocSubject = new Subject<any>();
  supportDoc$: Observable<any> = this.supportDocSubject.asObservable();

  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private clientService: ClientService,
    private ioService: IoService,
    private location: Location
  ) { }

  refreshContext() {
    console.log('refreshContext');
    this.supportDocSubject.next(this.supportDoc);
    this.supportDocsSubject.next(this.supportDocs);
  }

  launchSupport() {
    console.log('launchSupport');

    this.supportActive = true;
    this.supportActiveSubject.next(this.supportActive);

    this.loadSupportDocs();
  }

  closeSupport() {
    console.log('closeSupport');

    this.supportActive = false;
    this.supportActiveSubject.next(this.supportActive);
  }

  isSupportActive(): boolean {
    return this.supportActive;
  }

  loadDoc = async (docId: string) => {
    console.log('loadDoc:', docId);

    let supportDoc = await this.ioService.post('support/getDoc', {
      id: docId,
      activeRoute: this.location.path(),
      softwareVersion: this.version,
    });

    if (supportDoc) {
      this.supportDoc = supportDoc;
      this.supportDocSubject.next(this.supportDoc);
    } else {
      console.error('Failed to load support document:', docId);
    }
  }

  closeDoc() {
    console.log('closeDoc');
    this.supportDoc = null;
    this.supportDocSubject.next(this.supportDoc);
  }

  loadSupportDocs = async () => {
    console.log('loadSupportDocs');

    this.searchDocs('');
  }

  searchDocs = async (searchText: string) => {
    let supportDocs = await this.ioService.post('support/getDocs', {
      searchText: searchText,
      activeRoute: this.location.path(),
      softwareVersion: this.version,
    });

    if (supportDocs) {
      this.supportDocs = supportDocs;
      this.supportDocsSubject.next(this.supportDocs);
    }
  }

  supportPost(path: string, postData: any = {}) {
    return new Promise((resolve, reject) => {

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: 'ClientBearer ' + localStorage.getItem('token')
        })
      };

      if (!postData.rfId) {
        postData.rfId = this.clientService.getRfId();
      }

      if (path.substring(0, 1) === '/') {
        path = path.substr(1);
      }

      let supportServer = 'https://firetower-api-5nvmx.ondigitalocean.app/';
      supportServer = 'http://localhost:8080/';

      this.http.post<any>(supportServer + path, postData, httpOptions).toPromise()
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });

    });
  }

}
